/**
 *
 * @param {any} v
 * @returns {number}
 */
function toFloat(v) {
    if (typeof v === "string") {
        v = v.trim().replace(/,/, ".")
        const f = parseFloat(v)
        return isNaN(f) ? undefined : f
    } else if (isNaN(v)) {
        return undefined
    } else if (typeof v === "number") {
        return v
    }
    return undefined
}

/**
 *
 * @param {any} v
 * @param {number|null} [fallback]
 * @returns {number|null}
 */
function normalizeVat(v, fallback = 19) {
    const vat = toFloat(v)
    return typeof vat === "number" && !isNaN(vat) && vat > 0 ? vat : fallback
}

module.exports = {
    toFloat,
    normalizeVat,
}
